import { TypeSearchOperator } from 'civil-status/constants/type-search-operator';
import { FilterResearchNotificationsAnscOperator } from 'civil-status/view-models/notifications-list-ansc-operator';
import { FilterResearchNotificationsSide } from 'civil-status/view-models/notifications-list-side';

export const transformNotificationsResearchAnscOperator = (
  values: FilterResearchNotificationsSide | FilterResearchNotificationsAnscOperator
): {
  criteriRicercaNotifiche?: {
    dataInizio?: string;
    dataFine?: string;
    idAnsc?: string;
    idTipoEvento?: string;
    idTipoContenuto?: string;
    idStatoFlussoNotifiche?: string;
    idGenereNotifiche?: string;
    codiceOperatore?: string;
    idEventoSorgente?: string;
    descIntestatario?: string;
    codAzioneCanale?: string;
    flagRicercaOperatore?: boolean;
    comuneFormazione?: string;
    idFormula?: string;
  };
} => {
  const data = values as FilterResearchNotificationsAnscOperator;

  return {
    criteriRicercaNotifiche: {
      dataInizio: data.dateStart ? data.dateStart.toFormat('yyyy-MM-dd') : undefined,
      dataFine: data.dateEnd ? data.dateEnd.toFormat('yyyy-MM-dd') : undefined,
      idAnsc: data.idAnscNotification || undefined,
      codiceOperatore:
        data.searchOperatore === TypeSearchOperator.FiltroPerOperatore
          ? data.codOperator
          : undefined,
      idTipoContenuto: data.typeContentNotification?.id?.toString() || undefined,
      idStatoFlussoNotifiche: data.stateNotification?.id?.toString() || undefined,
      idGenereNotifiche: data.kindNotification?.id?.toString() || undefined,
      idEventoSorgente: data.idEventNationalNotification || data.idEventNotification || undefined,
      descIntestatario: data.owners || undefined,
      codAzioneCanale: data.scope || undefined,
      idTipoEvento: data.register?.id?.toString() || undefined,
      flagRicercaOperatore:
        data.searchOperatore === TypeSearchOperator.NessunOperatore
          ? false
          : data.searchOperatore === TypeSearchOperator.FiltroPerOperatore
          ? true
          : undefined,
      comuneFormazione: data.municipality || undefined,
      idFormula: data.annotationProposal || undefined,
    },
  };
};
